import { render, staticRenderFns } from "./ConfirmDeletion.vue?vue&type=template&id=c97cf620&"
import script from "./ConfirmDeletion.vue?vue&type=script&lang=js&"
export * from "./ConfirmDeletion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports